import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import InputAutocomplete from '@components/InputAutocomplete';
import { IJobOfferAssigneeOption } from '../JobOfferFilter';

interface AutoCompleteAssigneesProps {
    name: string;
    options: IJobOfferAssigneeOption[];
    onChange?: (value: string | string[]) => void;
    loading?: boolean;
}

export const AutoCompleteAssignees: React.FC<AutoCompleteAssigneesProps> = ({ name, options, onChange, loading }) => {
    return (
        <InputAutocomplete
            id="assigneeIds"
            name={name}
            multiple
            options={options}
            getOptionLabel={(option) => option.label}
            onChange={onChange}
            loading={loading}
            renderOption={(props, option) => (
                <li {...props} key={option.value}>
                    <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
                        <Avatar
                            src={option.avatarUrl || undefined}
                            sx={{ width: 32, height: 32 }}
                        >
                            {!option.avatarUrl && option.label?.[0]?.toUpperCase()}
                        </Avatar>
                        <Box>
                            <Typography variant="body2">{option.label}</Typography>
                            {option.email && (
                                <Typography variant="caption" color="text.secondary">
                                    {option.email}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                </li>
            )}
        />
    );
};

export default AutoCompleteAssignees;
